import React, { useEffect, useMemo } from 'react';
import { Dropdown, Form, Badge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'redux/store';
import { getLocks } from '../../../../../../../redux/slices/locksSlice';

type Props = {
  value: string[];
  onChange: (v: string[]) => void;
  disabled?: boolean;
  className?: string;
  zone_name?: string;
};

const LockSelect: React.FC<Props> = ({ value = [], onChange, disabled, className, zone_name }) => {
  const dispatch = useAppDispatch();
  const { locks, status } = useSelector((s: any) => s.locks);

  useEffect(() => {
    dispatch<any>(getLocks());
  }, [dispatch]);

  const options: string[] = useMemo(() => {
    const list = (locks || []).slice().sort((a: any, b: any) => {
      const z = a.zone_name.localeCompare(b.zone_name);
      return z !== 0 ? z : a.name.localeCompare(b.name);
    });
    return list.map((l: any) => `${l.zone_name}|${l.name}`);
  }, [locks]);

  const summary = status === 'loading' ? 'Loading…' : value.length === 0 ? 'None' : value.length <= 2 ? value.join(', ') : `${value.length} selected`;

  const toggleOne = (tag: string) => {
    const selected = value.includes(tag) ? value.filter((v) => v !== tag) : [...value, tag];
    onChange(selected);
  };

  const clearAll = () => onChange([]);
  const selectAll = () => onChange(options || []);

  return (
    <Form.Group className={className || 'mb-2 w-full'} controlId="form-LockSelect">
      <Form.Label>Locks</Form.Label>

      <Dropdown autoClose="outside" className="w-25  cursor-pointer">
        <Dropdown.Toggle as={Form.Control} readOnly value={summary} disabled={disabled || status === 'loading'} className="text-start" />
        <Dropdown.Menu
          style={{
            width: '100%',
            maxHeight: 320,
            overflowY: 'auto',
            minWidth: 0,
            cursor: 'pointer',
          }}
        >
          <Dropdown.Item onClick={clearAll}>None (no locks)</Dropdown.Item>
          <Dropdown.Item onClick={selectAll} disabled={!options.length}>
            All (select every lock)
          </Dropdown.Item>
          <Dropdown.Divider />

          {options.map((opt) => (
            <Dropdown.Item key={opt} onClick={() => toggleOne(opt)}>
              {value.includes(opt) ? '✓ ' : ''} {opt}
            </Dropdown.Item>
          ))}

          {options.length === 0 && status !== 'loading' && <div className="px-3 py-2 text-muted">No locks available</div>}
        </Dropdown.Menu>
      </Dropdown>
    </Form.Group>
  );
};

export default LockSelect;
